if (!customElements.get("product-quickform")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.querySelector("[name=id]").disabled = false;

      if (window.innerWidth > 680) {
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      } else {
        this.form
          .querySelector(".product-form__submit")
          ?.addEventListener("click", (event) => {
            event.preventDefault();
            document
              .querySelector("product-info")
              ?.scrollIntoView({ behavior: "smooth", block: "start" });
          });
      }
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector("cart-drawer"))
        this.submitButton.setAttribute("aria-haspopup", "dialog");

      this.hideErrors = this.dataset.hideErrors === "true";
    }

    connectedCallback() {

      var variantGroup = document.querySelectorAll('.selector-list');
      variantGroup.forEach( (element) => {
        let optionDrop = element.querySelectorAll('li');
        optionDrop.forEach( (option) => {
          option.addEventListener('click', function(){
            let heading = this.closest('.selector-list')?.querySelector('.selected-option__text');
            if( !heading ) return;
              heading.innerHTML = this.innerHTML;

              let selectedValue = option.getAttribute('value');
              let selectElement = this.closest('.product-form__input').querySelector('select');
                  selectElement.value = selectedValue;
              // Dispatch the change event
              let newEvent = new Event('change', {
                bubbles: true,
                cancelable: true
              });
              selectElement.dispatchEvent(newEvent);
          })
        })
      });

      document.addEventListener("scroll", () => {
        var scrollValue = window.scrollY;
        const footerElement = document.querySelector("footer");
        const stickyElement = document.querySelector(
          ".section-product__sticky"
        );

        const chatButton = document.querySelector("#widget-chat-button");

        const normalActElement = document.querySelector("product-info");
        if (
          !isElementPartiallyInViewport(footerElement) &&
          !isElementInViewport(normalActElement) &&
          scrollValue > 800
        ) {
          stickyElement.classList.add("active");
          if(window.innerWidth <= 767)
            chatButton.style.bottom = 100 + "px";
        } else {
          stickyElement.classList.remove("active");
          if(window.innerWidth <= 767)
            chatButton.style.bottom = 20 + "px";
        }
      });

      // Function to check if an element is in the viewport
      function isElementInViewport(el) {
        // Get the bounding rectangle of the element
        var rect = el.getBoundingClientRect();

        // Check if the element is within the viewport
        return (
          rect.top >= 0 && // Element top is above the bottom of the viewport
          rect.left >= 0 && // Element left is to the right of the left edge of the viewport
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) && // Element bottom is below the top of the viewport
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth) // Element right is to the left of the right edge of the viewport
        );
      }

      function isElementPartiallyInViewport(el) {
        var rect = el.getBoundingClientRect();
        return (
          rect.top < window.innerHeight && // Element top is below the top of the viewport
          rect.left < window.innerWidth && // Element left is to the left of the right edge of the viewport
          rect.bottom >= 0 && // Element bottom is above the bottom of the viewport
          rect.right >= 0 // Element right is to the right of the left edge of the viewport
        );
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.handleErrorMessage();

      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButton.classList.add("loading");
      this.querySelector(".loading__spinner").classList.remove("hidden");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
        });
    }

    async addRemoveProductGift(parsedState) {
      await fetch("/cart.js")
        .then((response) => response.json())
        .then((response) => {
          var _self = this;
          var items = response.items;

          var hasProduct = false;
          var productId = document.querySelector(
            'input[name="product-single-gift"]'
          )?.value;
          items.forEach(function (item, index) {
            if (item.id == productId) {
              hasProduct = true;
            }
          });

          if (productId && !hasProduct) {
            const threshold = parseInt(window.upsellProducts.cartThreshold);
            if (response.total_price >= threshold) {
              _self.addGiftProduct(productId, 1);
            } else {
              _self.cart.renderContents(parsedState);
            }
          } else {
            _self.cart.renderContents(parsedState);
          }
        });
    }

    addGiftProduct(product, quantity) {
      var data = {
        items: [
          {
            id: product,
            quantity: quantity,
          },
        ],
      };

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // If the value is an array of objects, handle it accordingly
          if (Array.isArray(data[key])) {
            for (let i = 0; i < data[key].length; i++) {
              const item = data[key][i];
              for (const itemKey in item) {
                if (item.hasOwnProperty(itemKey)) {
                  formData.append(`${key}[${i}][${itemKey}]`, item[itemKey]);
                }
              }
            }
          } else {
            // If the value is a simple key-value pair
            formData.append(key, data[key]);
          }
        }
      }

      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.cart.renderContents(response);
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }
  customElements.define("product-quickform", ProductForm);
}

